<ng-container *ngIf="!isTariffActivated; else successModal">
  <tax-modal-header>tariffs.modal.subscribe.header</tax-modal-header>

  <tax-modal-content>
    <div class="tariff-sum" data-qa="tariff-cost">{{ tariffCost | kzCurrency }}</div>
    <span data-qa="activation-description"
      >{{ 'tariffs.modal.subscribe.content' | translate }} «{{ tariff?.name }}»</span
    >
  </tax-modal-content>

  <tax-modal-footer>
    <button
      data-qa-button="activate-subscription"
      class="button_blue ui-kit-align-right"
      (click)="activateSubscription()"
      translate
    >
      tariffs.modal.subscribe.button
    </button>
  </tax-modal-footer>
</ng-container>

<ng-template #successModal>
  <tax-modal-header [onCloseEmittedData]="'success'"
    >tariffs.modal.subscribe.success.header</tax-modal-header
  >

  <tax-modal-content>
    <div class="write-off-sum" data-qa="tariff-cost">-{{ tariffCost | kzCurrency }}</div>
    <span data-qa="activation-description"
      >{{ 'tariffs.modal.subscribe.success.content' | translate }} «{{ tariff?.name }}»</span
    >
  </tax-modal-content>

  <tax-modal-footer>
    <button
      data-qa-button="close-modal"
      class="button_blue ui-kit-align-right"
      (click)="closeModal('success')"
      translate
    >
      button.continue
    </button>
  </tax-modal-footer>
</ng-template>
